<template>
  <div class="main-view-stage-3-custom">
    <document-cloud-handler
      :cloud-meta="getCloudMeta()"
      :rules="['single']"
      :class-cst="'cloud-button add-obhliadka white--text no-decoration'"
      icon-button
    />
    <documents-zip-download/>
    <!-- CTA na kopírovanie zoznamu požadovaných dokumentov do clipboardu -->
      <div class="podpis-event-banner">
        <div class="div-block-142">
          <img
            class="image-10"
            src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f3b_document%20icon.png"
            loading="lazy"
            alt=""
          >
          <div class="div-block-143">
            <div class="bold blc-color">Pošlite klientovi zoznam požadovaných dokumentov jedným klikom</div>
          </div>
        </div>
        <div class="div-block-146">
          <button
            class="w-button"
            @click="copyCloudRequiredFiles"
          >
            Kopírovať zoznam
          </button>
        </div>
      </div>
    <div class="stage-3-items-wrapper" v-if="loaded">
      <mortgage-item-cloud
        v-for="(cloud, key) in clouds"
        v-if="showCloud(cloud)"
        :key="key"
        :object="cloud"
      />
    </div>
    <div class="d-flex justify-content-center align-items-center" style="height: 100%" v-else>
      <v-progress-circular
        class="loading-spinner"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import MortgageItemCloud
  from "@/components/broker/KartaHypoteky/KartaHypotekyDetail/DocumentCompletion/MortgageItemCloud.vue";
import DocumentCloudHandler from "@/components/shared/PopupHandler/Popups/DocumentCloud/DocumentCloudHandler.vue";
import DocumentsZipDownload
  from "@/components/broker/KartaHypoteky/KartaHypotekyDetail/DocumentCompletion/DocumentsZipDownload.vue";
import {mapGetters} from "vuex";

export default {
  name: "DocumentCompletion",
  components: {
    DocumentsZipDownload,
    DocumentCloudHandler,
    MortgageItemCloud,
  },
  props: {
    mortgage: [Object, null],
    applicant: [Object, null],
    coApplicant: [Object, null],
  },
  computed: {
    ...mapGetters({
      cloudsGetter: "mortgageDetailCloud/getClouds",
    }),
  },
  watch: {
    cloudsGetter(clouds) {
      this.clouds = clouds;
    },
  },
  async created () {
    await this.$store.dispatch("mortgageDetailCloud/initializeClouds");
    this.clouds = this.$store.getters["mortgageDetailCloud/getClouds"];
    this.loaded = true;
  },
  methods: {
    showCloud(cloud) {
      if (cloud.invisible) return false;
      if (cloud.type !== "mortgage") return true;
      return Number(this.mortgage.suma_nadobudnutie || 0) > 0
        || this.mortgage.hlavny_ucel === "nadobudnutie"
        || (!this.mortgage.hlavny_ucel && this.mortgage.ciel_prva_analyza === "nadobudnutie");
    },
    getCloudMeta () {
      return this.$store.getters["mortgageDetailCloud/getFullClouds"];
    },
    copyCloudRequiredFiles() {
      const cloudMetaToCopy = this.clouds.filter((c) => this.showCloud(c)).map((c) => {
        return {
          key: c.label,
          value: c.missingFiles.map((m) => m.name)
        }
      });

      this.copyVerticalTable(cloudMetaToCopy);
      this.$store.commit("appState/setSuccessMessage", {
          text: "Zoznam bol skopírovaný",
          type: "success"
      });
    },
    async copyVerticalTable(data) {
      if (!Array.isArray(data) || data.length === 0) return;

      const html = `
        <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse; text-align:left;">
          ${data
            .map(row => {
              const values = (Array.isArray(row.value) ? row.value : [row.value])
                .map(v => `<tr><td style="background:#fff;">${v}</td></tr>`)
                .join("");
              return `
                <tr><td style="background:#e0e0e0; font-weight:bold;">${row.key}</td></tr>
                ${values}
              `;
            })
            .join("")}
        </table>`;

      const text = data
        .map(row => [row.key, ...(Array.isArray(row.value) ? row.value : [row.value])].join("\n"))
        .join("\n");

      try {
        if (navigator.clipboard && window.ClipboardItem) {
          await navigator.clipboard.write([
            new ClipboardItem({
              "text/html": new Blob([html], { type: "text/html" }),
              "text/plain": new Blob([text], { type: "text/plain" })
            })
          ]);
        } else {
          const ta = document.createElement("textarea");
          ta.value = text;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
      } catch (err) {
        console.error("Copy failed", err);
      }
    }
  },
  data: () => ({
    clouds: [],
    loaded: false,
    foundedProperties: [],
    applicantInfo: {},
    coApplicantInfo: {},
  }),
}
</script>

<style lang="scss" scoped>

.bcg-loading {
  position: fixed;
  background-color: rgba(0, 0, 0, 25%);
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.stage-3-items-wrapper .div-block-102 {
  flex: 0 0 25%;
}

.stage-3-items-wrapper {
  display: -ms-grid;
  display: grid;
  grid-auto-columns: 1fr 1fr 1fr 1fr;
  -ms-grid-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
}

@media screen and (max-width: 991px) {
  .stage-3-items-wrapper {
    grid-auto-columns: 1fr 1fr 1fr;
    -ms-grid-columns: 1fr 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
  }

}

@media screen and (max-width: 767px) {
  .stage-3-items-wrapper {
    grid-auto-columns: 1fr 1fr;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 500px) {
  .stage-3-items-wrapper {
    grid-auto-columns: 1fr;
    -ms-grid-columns: 1fr;
    grid-template-columns: 1fr;
  }
}


</style>
